import { render } from "./Navbar.vue?vue&type=template&id=1758c63c"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\tieke\\Documents\\Studieverenigingen\\SV Sticky\\Maatschappelijk karakter 2021-2022\\Goede doelen dag\\goede-doelen-dag\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__